import Form from 'react-bootstrap/Form';

import type { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clientError?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  serverErrors?: string[];
}

export function FormFeedback({ clientError, serverErrors }: Props) {
  if (clientError || serverErrors) {
    return (
      // Force display as Form Control Feedback will by default only show
      // when it's a direct sibling of a Form Control
      <Form.Control.Feedback type="invalid" style={{ display: 'initial' }}>
        <ul className="list-unstyled">
          {clientError && <li>{clientError.message?.toString()}</li>}
          {serverErrors?.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      </Form.Control.Feedback>
    );
  }
}
